import React from "react";
import Image from "gatsby-image";
import { JanczakiImage } from "./JanczakiImage";

import Video1 from "assets/videos/janczaki/jan_1.mp4";
import Video2 from "assets/videos/janczaki/jan_2.mp4";
import Video3 from "assets/videos/janczaki/jan_3.mp4";
import Video4 from "assets/videos/janczaki/jan_4.mp4";
import Video1c from "assets/videos/janczaki/jan_1c.mp4";

export const JanczakiData = () => {
  const images = JanczakiImage();
  return {
    color: "#2DD1C7",
    title: "Janczaki",
    seo:
      "Przedstawiamy rodzinę Janczaków! To różne rodzaje kasz (i nie tylko) o prawdziwie ludzkich cechach charakteru.",
    slug: "janczaki",
    hero: {
      title: "Nowoczesny branding i strategia marki.",
      color: "#2DD1C7",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Brand heroes, które zwiększą sprzedaż",

      technologies: [
        "Identyfikacja wizualna",
        "UX Workshops",
        "Content Marketing",
        "Plan marketingowy",
      ],
      text:
        "Przedstawiamy rodzinę Janczaków! To różne rodzaje kasz (i nie tylko) o prawdziwie ludzkich cechach charakteru. Są zabawni, pozytywnie nastawieni do życia i co najważniejsze - uwielbiają zdrowe i naturalne jedzenie. Projekt dopełniają wykonane przez nas barwne ilustracje i grafiki na opakowaniach. Dzięki temu trudno przejść obok nich obojętnie.",
      list: [
        "Stworzyliśmy brand heroes",
        "Opracowaliśmy wizerunek i komunikację marki",
        "Zaprojektowaliśmy grafiki i ilustracje ",
        "Przygotowaliśmy harmonogram prac i plan marketingowy",
        "Zaproponowaliśmy działania w mediach społecznościowych",
      ],
    },
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.jan_1.childImageSharp.fluid}
        />
      ),
    },
    headers: {
      first: "Opracowanie identyfikacji wizualnej  ",
      second: "Rodzina Janczaków",
    },
    text_boxes: {
      first: {
        title: "Wartościowy przekaz w atrakcyjnej formie",
        text:
          "Celem naszej współpracy z producentem kasz było dotarcie do większej ilości klientów, a szczególnie przedstawienie produktów osobom młodym. W tym celu posłużyliśmy się brand heroes, które w zabawny, ale również treściwy sposób reprezentują oferowane produkty. ",
      },
      second: {
        title: "Babcia Gryczana - tradycja w kuchni",
        text:
          "Przedstawicielka tradycyjnej polskiej kuchni, pysznych i prostych w przygotowaniu posiłków z kasz. Symbol produktów ekologicznych i naturalnych oraz bezpiecznych upraw, które są zgodne z dobrymi praktykami rolnymi.",
      },
      third: {
        title: "Tata Ryż - miłośnik domowej kuchni",
        text:
          "Głowa rodziny. Idendentyfikuje się z osobami pracującymi od poniedziałku do piątku, od 9 do 17. Wyjechał do większego miasta i tu założył rodzinę. Idzie z duchem czasu, ale jednocześnie reprezentuje smaki dzieciństwa, jest tradycjonalistą, miłośnikiem regionalnych potraw i smakoszem. Uwielbia po pracy zjeść dobry posiłek.",
      },
      fourth: {
        title: "Córka Kukurydza - zbilansowane odżywianie",
        text:
          "Reprezentanka młodszego pokolenia dbającego o swój wygląd i zdrowie. Kojarzona z rolą kaszy w zbilansowanym odżywianiu, diecie zdrowotnej i odchudzającej oraz wykorzystaniu tych produktów w kuchniach nowoczesnych (wegetariańskich, wegańskich, eco, bio, gluten-free itp.).",
      },
      fifth: {
        title: "Synek Jaglany - zdrowe posiłki w każdym wieku",
        text:
          "Najmłodszy członek rodziny doskonale reprezentuje kasze jako produkty, które są potrzebne dla zdrowia człowieka w każdym wieku. Zawierają one cenne minerały, witaminy i błonnik.",
      },
    },
    full_images: {
      first: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.jan_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.jan_2f.childImageSharp.fluid}
          />
        ),
      },
      third: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.jan_3f.childImageSharp.fluid}
          />
        ),
      },
      fourth: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.jan_4f.childImageSharp.fluid}
          />
        ),
      },
      fifth: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.jan_5f.childImageSharp.fluid}
          />
        ),
      },
      sixth: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.jan_6f.childImageSharp.fluid}
          />
        ),
      },
      seventh: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.jan_7f.childImageSharp.fluid}
          />
        ),
      },
      eighth: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.jan_8f.childImageSharp.fluid}
          />
        ),
      },
    },
    video: {
      first: Video1,
      second: Video2,
      third: Video3,
      fourth: Video4,
    },
    video_content: {
      first: Video1c,
    },
  };
};
